import request from './request.js'
// import requestocy from './requestocy.js'
import school from "./school.js"

//获取图形验证码
function getverification(time) {
    return request('/login/generateValidateCode', "POST", {
        time: time
    })
}
//发送短信验证码
function sendsms(phone, time, imageCode) {
    return request('/login/getVerificationCode', "POST", {
        phone,
        time,
        imageCode
    })
}
//发送短信验证码班课
function sendsmscourse(phone, time, imageCode) {
    return request('/login/mobile/getVerificationCode', "POST", {
        phone,
        time,
        imageCode
    })
}
//手机号登录
function loginforphone(phone, code, time, imageCode, type) {
    return request('/login/loginByVerificationCode', "POST", {
        phone,
        code,
        time,
        imageCode,
        type
    })
}
//班课手机号登录
function loginByVerificationCodeForCourse(phone, code, time, imageCode, type) {
    return request('/school/login/loginByVerificationCodeForCourse', "POST", {
        phone,
        code,
        time,
        imageCode,
        type
    })
}
//观看方式
function roomwatchytype() {
    return request('/LiveRoomWatchType/getInfo', "POST", {
    })
}
//type1免费观看
function roomwatchytypefree() {
    return request('/LiveRoomWatchType/free', "POST", {
    })
}
//type2付费观看
function roomwatchytypepay(stype) {
    return request('/LiveRoomWatchType/pay', "POST", {
        stype
    })
}
//type3密码观看
function roomwatchytypeencryption(password) {
    return request('/LiveRoomWatchType/encryption', "POST", {
        password
    })
}
//type4账号观看
function roomwatchytypephone(phone) {
    return request('/LiveRoomWatchType/phone', "POST", {
        phone
    })
}
//检查支付状态
function roomwatchytypeverifyPay(orderNum) {
    return request('/LiveRoomWatchType/verifyPay', "POST", {
        orderNum
    })
}
//type5报名观看
function roomwatchytypesubmit(data) {
    return request('/LiveRoomWatchType/submit', "POST", data)
}
//type6邀请码观看
function roomwatchytypeinvite(code) {
    return request('/LiveRoomWatchType/invite', "POST", {
        code
    })
}
//验证观看方式是否认证过
function roomwatchytypeverify() {
    return request('/LiveRoomWatchType/verify', "POST", {
    })
}
//获取房间token
function getusertoken(nickname, userLogin, isUpdate) {
    return request("/room/getUserToken", "POST", {
        nickname,
        userLogin,
        isUpdate
    })
}
//获取房间基础信息
function roomconfig() {
    return request('/livec/liveRoom/allConfig', "POST", {

    })
}
//获取房间自定义菜单信息
function getroomconfigtags() {
    return request('/roomTagConfig/getRoomConfigTags', "POST", {

    })
}
//获取房间视频信息
function getroombindvideos() {
    return request('/roomTagConfig/getRoomBindVideos', "POST", {
    })
}
//获取礼物信息
function getclientgift() {
    return request('/liveGiftConfig/getClientGift', "POST", {
    })
}
//获取二维码
function getwxqrcode(path) {
    return request('/login/getWxQrCode', "POST", {
        path
    })
}
//检查二维码
function checkwxqrcode(code) {
    return request('/login/checkWxQrCode', "POST", {
        code
    })
}
//标记二维码已使用
function savewxqrcode(code) {
    return request('/ocLogin/saveWxQrCode', "POST", {
        code
    })
}
//创建礼物支付订单
function createpcorderbygift(id) {
    return request('/pay/createPcOrderByGift', "POST", {
        id
    })
}
//检查礼物订单支付状态
function wxcheckorder(orderNum) {
    return request('/pay/checkOrder', "POST", {
        orderNum
    })
}

//获取房间基本信息
function getwatchroombasevo() {
    return request('/room/getWatchRoomBaseVo', "POST", {

    })
}
//获取房间跑马灯
function getroommarquee() {
    return request('/roomMarquee/info', "POST", {
    })
}
//打赏获取支付链接
function createorderbyreward(price) {
    return request('/pay/createPcOrderByReward', "POST", {
        price
    })
}
//设置观看人数
function setwatchlookbase() {
    return request('/roomConfig/setWatchLookBase', "POST", {
    })
}
//获取累计观看人数
function getwatchlookbase() {
    return request('/roomConfig/getWatchLookBase', "POST", {

    })
}
//获取用户连麦信息
function getusertrtcsign(account) {
    return request('/room/getUserTRTCSign', "POST", {
        account
    })
}
//获取商品列表
function getroomcommodity(page, pageSize) {
    return request('/roomConfig/getRoomCommodity', "POST", {
        page,
        pageSize,
    })
}
//支付商品
function createcommodity(id, account) {
    return request('/pay/createPCOrderByCommodity', "POST", {
        id,
        account
    })
}
//上报外部商品点击
function escalation(commodityId) {
    return request('/room/escalationH5Check', "POST", {
        commodityId
    })
}
//获取累计观看人数
function getlookbase() {
    return request('/roomConfig/getWatchLookBase', "POST", {

    })
}
//获取客服列表
function getroomcustomer() {
    return request('/roomCustomer/list', "POST", {

    })
}
//获取关注信息
function getfollow() {
    return request('/roomConfig/getFollow', "POST", {

    })
}
//获取回看地址
function getbackinfo() {
    return request('/roomLookBack/info', "POST", {

    })
}
//签到
function signadd(signId) {
    return request('/roomUserSign/add', "POST", {
        signId
    })
}
//续签到
function needsign() {
    return request('/roomUserSign/needSign', "POST", {

    })
}
//聊天设置
function livechatinfo() {
    return request('/LiveChat/info', "POST", {

    })
}
//校验token
function livechecktoken(token) {
    return request('/login/checkToken', "POST", {

    })
}
//获取观看地址
function livewatchurl() {
    return request('/room/watchUrl', "POST", {
    })
}
//取消认证
function delwatchtype() {
    return request('/LiveRoomWatchType/delWatchType', "POST", {
    })
}
//添加系统数据
function addsystemlog(account) {
    return request('/room/addSystemLog', "POST", {
        account
    })
}
//添加商品点击,ocy
function addCommodityClick(data) {
    return request('/roomConfig/addCommodityClick', "POST",
        data
    )
}
//观看时长上报,ocy
function AddWatchTime(data) {
    return request('/userWatchClassStatistics/AddWatchTime', "POST",
        data
    )
}
//观看时长结束上报,ocy
function AddWatchTimeEnd(data) {
    return request('/userWatchClassStatistics/AddWatchTimeEnd', "POST",
        data
    )
}
//获取评价列表
function getAllPassEvaluate(lecturerId) {
    return request('/roomTagConfig/getAllPassEvaluate', "POST", {
        lecturerId
    })
}
//发表讲师评价
function addTeacherEvaluate(lecturerId, headUrl, account, nickName, evaluate, score) {
    return request('/roomTagConfig/addTeacherEvaluate', "POST", {
        lecturerId,
        headUrl,
        account,
        nickName,
        evaluate,
        score
    })
}
//获取推荐商品信息
function getPromotionInfo(promotionCode) {
    return request('/promotion/link/queryLink', "POST", {
        promotionCode
    })
}
//获取推荐商品信息
function getRecommendCommodityInfo() {
    return request('/room/getRecommendCommodityInfo', "POST", {

    })
}
//推荐商品上报
function escalationCheck(data) {
    return request('/room/escalationCheck', "POST", data)
}
//PC支付-推荐商品
function createPCOrderByRecommendCommodity(account, id) {
    return request('/pay/createPCOrderByRecommendCommodity', "POST", {
        account,
        id
    })
}
//获取商品入口图片
function getCommodityListIcon() {
    return request('/roomConfig/getCommodityListIcon', "POST", {

    })
}
//获取机构logo和背景（全局）
function getCharacter() {
    return request('/room/getCharacter', "POST", {
    })
}
//获取讲师信息
function getLecturerInfo(lecturerId) {
    return request('/roomTagConfig/getLecturerInfo', "POST", {
        lecturerId
    })
}
//获取讲师信息
function getChannelData(id) {
    return request('/channel/getChannelData', "POST", {
        id
    })
}
// 直播互动次数上报
function addMsgCount(data) {
    return request('/AddSendMsgCount', "POST", data)
}

// 卡片采集
function SubmitCardList(data) {
    return request('/interfaceCard/SubmitCardList', "POST", data)
}

// 订单场控点击记录采集
function addOrderControlRecord(data) {
    return request('/orderField/addOrderControlRecord', "POST", data)
}

// 抽奖---获取直播间是否有正在进行的抽奖
function getRoomHavingDraw() {
    return request('/draw/getRoomHavingDraw', "POST",)
}

// 抽奖---获取直播间抽奖信息
function getDraw(id) {
    return request('/draw/getDraw', "POST", { id })
}

// 抽奖---查看是否中奖
function checkPrizeUser(data) {
    return request('/draw/checkPrizeUser', "POST", data)
}

// 抽奖---查看中奖名单
function getPrizeCache(drawId, index, count) {
    return request('/draw/getPrizeCache', "POST", { drawId, index, count })
}

// 抽奖---提交兑奖信息
function submitDrawList(data) {
    return request('/draw/submitDrawList', "POST", data)
}

// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// 班课部分
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
// -
//获取班课基础信息
function getCourseInfo() {
    return request('/school/api/course/getCourseInfo', "POST", {
    })
}
function verifyChannel(code) {
	return request(`/channel/verifyChannel?code=${code}`, "POST", {})
}
//获取班课子母表
function getCourseClass() {
    return request('/school/api/course/getCourseClass', "POST", {
    })
}
//获取班课课程表
function getCourseList(courseClassId) {
    return request('/school/api/course/getCourseList', "POST", {
        courseClassId
    })
}
//获取班课用户信息
function getUserInfo() {
    return request('/school/personalCenter/getUserInfo', "POST", {

    })
}
//获取个人中心绑定信息
function getPersonalCenterInfo() {
    return request('/school/personalCenter/getPersonalCenterInfo', "POST", {

    })
}
//修改班课用户信息
function updateUserInfo(data) {
    return request('/school/personalCenter/updateUserInfo', "POST",
        data
    )
}
//获取班课观看历史
function getUserWatchHistoryList(page, pageSize) {
    return request('/personalCenter/getUserWatchHistoryList', "POST", {
        page,
        pageSize
    })
}
//获取绑定微信授权码
function getWxEmpowerQrCode(path) {
    return request('/appointClassVaildateController/getWxEmpowerQrCode', "POST", {
        path
    })
}
//获取章节index
function getCourseIndex(sectionId) {
    return request('/api/course/getCourseIndex', "POST", {
        sectionId
    })
}
//验证观看方式
function checkUser() {
    return request('/school/login/checkUser', "POST", {

    })
}
//验证手机号占用状态
function loginByAppointVerificationCode(data) {
    return request('/appointClassVaildateController/loginByAppointVerificationCode', "POST", data)
}
//检查二维码
function checkWxEmpowerQrCode(code) {
    return request('/appointClassVaildateController/checkWxEmpowerQrCode', "POST", {
        code
    })
}
//绑定手机号
function mergeUser(phone) {
    return request('/appointClassVaildateController/mergeUser', "POST", {
        phone
    })
}
//验证手机号绑定状态
function verificationByRebind(data) {
    // return request('/appointClassVaildateController/verificationByRebind', "POST", data)
    return request('/login/mobile/verificationByRebindUnCheck', "POST", data)
}
//获取手机号账户信息
function getUserClassData(phone) {
    return request('/appointClassVaildateController/getUserClassData', "POST", {
        phone
    })
}
//绑定微信账号(无冲突)
function empowerUserByNoConflict(data) {
    return request('/appointClassVaildateController/empowerUserByNoConflict', "POST", data)
}
//获取微信账号对比表
function getUserClassDataByWxId(userId) {
    return request('/appointClassVaildateController/getUserClassDataByWxId', "POST", {
        userId
    })
}
//绑定微信账号(冲突合并)
function empowerUserByPC(userId) {
    return request('/appointClassVaildateController/empowerMergeUser', "POST", {
        userId
    })
}
//班课密码验证
function checkEncryption(passWord) {
    return request('/school/login/checkEncryption', "POST", {
        passWord
    })
}
//班课账号验证
function checkAccount(phone) {
    return request('/school/login/checkAccount', "POST", {
        phone
    })
}
//班课付费观看
function createPcOrderByCourseWatch(account) {
    return request('/pay/createPcOrderByCourseWatch', "POST", {
        account
    })
}
//班课数据上报
function addUserWatchData(data) {
    return request('/school/userWatchClassStatistics/addUserWatchData', "POST", data)
}

//最后一次登录上报
function UserLoginData(data) {
    return request('/school/userWatchClassStatistics/userLoginData', "POST", data)
}
//我的课程
function getUserCourseList(page, pageSize) {
    return request('/school/personalCenter/getUserCourseList', "POST", {
        page,
        pageSize
    })
}
export default {
    ...school,
    getUserInfo,
    getLecturerInfo,
    mergeUser,
    UserLoginData,
    getChannelData,
    getUserCourseList,
    empowerUserByPC,
    addUserWatchData,
    checkEncryption,
    checkAccount,
    createPcOrderByCourseWatch,
    getUserClassDataByWxId,
    empowerUserByNoConflict,
    loginByAppointVerificationCode,
    verificationByRebind,
    loginByVerificationCodeForCourse,
    checkUser,
    getUserClassData,
    checkWxEmpowerQrCode,
    getWxEmpowerQrCode,
    getCourseIndex,
    getPersonalCenterInfo,
    getUserWatchHistoryList,
    updateUserInfo,
    getCourseList,
    getCourseInfo,
    verifyChannel,
    getCourseClass,
    sendsms,
    AddWatchTime,
    getCharacter,
    getRecommendCommodityInfo,
    createPCOrderByRecommendCommodity,
    escalationCheck,
    AddWatchTimeEnd,
    getAllPassEvaluate,
    addTeacherEvaluate,
    addsystemlog,
    sendsmscourse,
    getverification,
    loginforphone,
    roomwatchytype,
    getusertoken,
    roomconfig,
    getroomconfigtags,
    getroombindvideos,
    getclientgift,
    getwxqrcode,
    checkwxqrcode,
    savewxqrcode,
    createpcorderbygift,
    wxcheckorder,
    roomwatchytypeverify,
    roomwatchytypefree,
    roomwatchytypeencryption,
    getwatchroombasevo,
    getroommarquee,
    getCommodityListIcon,
    roomwatchytypepay,
    roomwatchytypeinvite,
    roomwatchytypeverifyPay,
    roomwatchytypephone,
    createorderbyreward,
    setwatchlookbase,
    getwatchlookbase,
    roomwatchytypesubmit,
    getusertrtcsign,
    getroomcommodity,
    createcommodity,
    escalation,
    getlookbase,
    getroomcustomer,
    getfollow,
    getbackinfo,
    signadd,
    needsign,
    livechatinfo,
    livechecktoken,
    livewatchurl,
    delwatchtype,
    addCommodityClick,
    addMsgCount,
    SubmitCardList,
    getRoomHavingDraw,
    addOrderControlRecord,
    checkPrizeUser,
    getPrizeCache,
    submitDrawList,
    getDraw,
    getPromotionInfo
}